import { themeAtom } from "../../shared/atoms";
import { useAtomValue } from "jotai";
import { Children, isValidElement, useEffect, useMemo, useState } from "react";
import { twMerge } from "tailwind-merge";

// TODO Merge with other tabs
const Tabs = ({ children, height = "h-full", overflow = "overflow-auto", initialActiveTab = "" }) => {
  const tabs = useMemo(
    () =>
      Children.toArray(children).filter((child) => {
        return isValidElement(child) && child.props?.label;
      }),
    [children],
  );
  const defaultTab = tabs[0]?.props.label;
  const [activeTab, setActiveTab] = useState(initialActiveTab || defaultTab);
  const theme = useAtomValue(themeAtom);

  useEffect(() => {
    if (!tabs.length) {
      return;
    }

    if (!activeTab || !tabs.some((child) => child.props.label === activeTab)) {
      setActiveTab(initialActiveTab || defaultTab);
    }
  }, [activeTab, defaultTab, initialActiveTab, tabs]);

  useEffect(() => {
    if (!initialActiveTab) return;

    const hasRequestedTab = tabs.some((child) => child?.props?.label === initialActiveTab);
    if (hasRequestedTab) {
      setActiveTab(initialActiveTab);
    }
  }, [initialActiveTab, tabs]);

  const handleClick = (e, newActiveTab) => {
    e.preventDefault();
    setActiveTab(newActiveTab);
  };

  return (
    <div className={`mx-auto flex h-full w-full flex-col gap-5 ${height}`}>
      <div className="justify-between">
        {tabs.map((child) => (
          <button
            key={child.props.label}
            className={`${activeTab === child.props.label ? "border-b-2 border-green font-medium text-green" : theme.uwhcAssistant.text} mr-6 flex-1 py-2 pl-2 pr-2 text-[14px] ${theme}`}
            onClick={(e) => handleClick(e, child.props.label)}
          >
            {child.props.label}
          </button>
        ))}
      </div>

      <div
        className={twMerge(
          `flex-1 ${overflow} ${height}`,
          "[&::-webkit-scrollbar]:w-1.5",
          "[&::-webkit-scrollbar-track]:bg-transparent",
          "[&::-webkit-scrollbar-thumb]:rounded-full",
          theme.uwhcAssistant.tableScroll,
          theme.uwhcAssistant.scrolHover,
        )}
      >
        {tabs.map((child) => {
          if (child.props.label === activeTab) {
            return <div key={child.props.label}>{child.props.children}</div>;
          }
          return null;
        })}
      </div>
    </div>
  );
};

const Tab = ({ label, children }) => {
  return (
    <div label={label} className="hidden">
      {children}
    </div>
  );
};
export { Tabs, Tab };
